document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
  initTiltCards();
  initRotadorProducto();
  initCarritoPack();
});

function initCarritoPack() {
  var MT_MAX_UNIDADES = 3;

  function leerTiers(cell) {
    var tiersScript = cell.querySelector('[data-mt-cart-pack-tiers]');
    if (!tiersScript) return null;
    try {
      var tiers = JSON.parse(tiersScript.textContent);
      return (tiers && tiers.length) ? tiers : null;
    } catch (err) {
      return null;
    }
  }

  function tierActual(cell, tiers, input) {
    var currentVariantId = Number(input.getAttribute('data-quantity-variant-id'));
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].id === currentVariantId) return tiers[i];
    }
    return null;
  }

  // Muestra unidades reales (3, 4, 5...) en vez del número de líneas de Shopify (siempre 1).
  document.querySelectorAll('[data-mt-cart-pack]').forEach(function (cell) {
    var tiers = leerTiers(cell);
    var input = cell.querySelector('.quantity__input');
    if (!tiers || !input) return;
    var actual = tierActual(cell, tiers, input);
    if (actual) {
      input.value = actual.units;
      input.setAttribute('readonly', 'readonly');
      if (actual.units >= MT_MAX_UNIDADES) {
        var plusBtnInit = cell.querySelector('.quantity__button[name="plus"]');
        if (plusBtnInit) plusBtnInit.disabled = true;
      }
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity__button');
    if (!btn) return;
    var cell = btn.closest('[data-mt-cart-pack]');
    if (!cell) return;

    var isPlus = btn.getAttribute('name') === 'plus';
    var isMinus = btn.getAttribute('name') === 'minus';
    if (!isPlus && !isMinus) return;

    var tiers = leerTiers(cell);
    var input = cell.querySelector('.quantity__input');
    if (!tiers || !input) return;

    var actual = tierActual(cell, tiers, input);
    if (!actual) return;

    if (isPlus && actual.units >= MT_MAX_UNIDADES) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }

    var unidadesObjetivo = isPlus ? actual.units + 1 : actual.units - 1;
    var targetTier = null;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].units === unidadesObjetivo) { targetTier = tiers[i]; break; }
    }
    if (!targetTier || !targetTier.available) return;

    var currentVariantId = actual.id;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var plusBtn = cell.querySelector('.quantity__button[name="plus"]');
    var minusBtn = cell.querySelector('.quantity__button[name="minus"]');
    if (plusBtn) plusBtn.disabled = true;
    if (minusBtn) minusBtn.disabled = true;
    cell.style.opacity = '0.5';
    cell.style.pointerEvents = 'none';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(currentVariantId), quantity: 0 })
    })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: targetTier.id, quantity: 1 }] })
        });
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        window.location.reload();
      });
  }, true);
}

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var groups = {};
  els.forEach(function (el) {
    var group = el.closest('[data-mt-stagger]');
    var key = group ? group : el;
    if (!groups[key]) groups[key] = [];
  });
  var counters = new WeakMap();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var group = el.closest('[data-mt-stagger]');
      if (group) {
        var n = counters.get(group) || 0;
        el.style.setProperty('--mt-delay', (n * 0.09) + 's');
        counters.set(group, n + 1);
      }
      el.classList.add('mt-visible');
      observer.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('.mt-contador[data-hasta]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var hasta = parseFloat(el.getAttribute('data-hasta')) || 0;
      var sufijo = el.getAttribute('data-sufijo') || '';
      var dur = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var prog = Math.min((ts - inicio) / dur, 1);
        var ease = 1 - Math.pow(1 - prog, 3);
        el.textContent = Math.round(hasta * ease) + sufijo;
        if (prog < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-img-principal]');
  var minis = galeria.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.style.opacity = '0';
      setTimeout(function () {
        principal.src = full;
        principal.alt = alt;
        principal.style.opacity = '1';
      }, 160);
      minis.forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });
}

function initVariantesProducto() {
  var wrap = document.querySelector('[data-mt-variantes]');
  if (!wrap) return;
  var dataEl = document.getElementById('mt-variantes-json');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var swatchesColor = wrap.querySelectorAll('[data-mt-swatch-color]');
  var pillsCantidad = wrap.querySelectorAll('[data-mt-cantidad]');
  var inputId = document.querySelector('[data-mt-variant-id]');
  var precioEl = document.querySelector('[data-mt-precio-actual]');
  var precioAntesEl = document.querySelector('[data-mt-precio-antes]');
  var botonComprar = document.querySelector('[data-mt-boton-comprar]');
  var stockAviso = document.querySelector('[data-mt-stock-aviso]');
  var valorColorLabel = document.querySelector('[data-mt-opcion-valor="color"]');
  var valorCantidadLabel = document.querySelector('[data-mt-opcion-valor="cantidad"]');
  var galeria = document.querySelector('[data-mt-galeria]');

  function formatoPrecio(centavos) {
    return (centavos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
  }

  var colorActivo = (wrap.querySelector('[data-mt-swatch-color].mt-activo') || swatchesColor[0] || {}).getAttribute
    ? (wrap.querySelector('[data-mt-swatch-color].mt-activo') || swatchesColor[0]).getAttribute('data-mt-swatch-color')
    : null;
  var cantidadActiva = (wrap.querySelector('[data-mt-cantidad].mt-activo') || pillsCantidad[0] || {}).getAttribute
    ? (wrap.querySelector('[data-mt-cantidad].mt-activo') || pillsCantidad[0]).getAttribute('data-mt-cantidad')
    : null;

  function buscarVariante() {
    return variantes.filter(function (v) {
      var opciones = v.opciones || [];
      var okColor = colorActivo ? opciones.indexOf(colorActivo) > -1 : true;
      var okCantidad = cantidadActiva ? opciones.indexOf(cantidadActiva) > -1 : true;
      return okColor && okCantidad;
    })[0];
  }

  function refrescarPrecios() {
    pillsCantidad.forEach(function (pill) {
      var valor = pill.getAttribute('data-mt-cantidad');
      var v = variantes.filter(function (item) {
        var o = item.opciones || [];
        return o.indexOf(colorActivo) > -1 && o.indexOf(valor) > -1;
      })[0];
      if (!v) return;
      var precioSpan = pill.querySelector('.mt-cantidad-precio');
      if (precioSpan) precioSpan.textContent = formatoPrecio(v.price);
      var ahorroSpan = pill.querySelector('.mt-cantidad-ahorro');
      if (ahorroSpan && v.compare_at_price > v.price) {
        ahorroSpan.textContent = 'Ahorras ' + formatoPrecio(v.compare_at_price - v.price);
      }
    });
  }

  function aplicar(disparado) {
    var variante = buscarVariante();
    if (!variante) return;

    if (valorColorLabel && colorActivo) valorColorLabel.textContent = colorActivo;
    if (valorCantidadLabel && cantidadActiva) valorCantidadLabel.textContent = cantidadActiva;
    if (inputId) inputId.value = variante.id;
    if (precioEl) precioEl.textContent = formatoPrecio(variante.price);
    if (precioAntesEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAntesEl.textContent = formatoPrecio(variante.compare_at_price);
        precioAntesEl.style.display = '';
      } else {
        precioAntesEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      var disponible = variante.available;
      botonComprar.disabled = !disponible;
      botonComprar.textContent = disponible
        ? botonComprar.getAttribute('data-texto-disponible')
        : botonComprar.getAttribute('data-texto-agotado');
    }
    if (stockAviso) {
      stockAviso.classList.toggle('mt-agotado', !variante.available);
      stockAviso.textContent = variante.available
        ? stockAviso.getAttribute('data-texto-disponible')
        : stockAviso.getAttribute('data-texto-agotado');
    }
    if (galeria && variante.featured_image) {
      var principal = galeria.querySelector('[data-mt-img-principal]');
      if (principal && disparado) {
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = variante.featured_image;
          principal.style.opacity = '1';
        }, 160);
      }
    }
  }

  swatchesColor.forEach(function (s) {
    s.addEventListener('click', function () {
      colorActivo = s.getAttribute('data-mt-swatch-color');
      swatchesColor.forEach(function (el) { el.classList.remove('mt-activo'); });
      s.classList.add('mt-activo');
      refrescarPrecios();
      aplicar(true);
    });
  });

  pillsCantidad.forEach(function (p) {
    p.addEventListener('click', function () {
      cantidadActiva = p.getAttribute('data-mt-cantidad');
      pillsCantidad.forEach(function (el) { el.classList.remove('mt-activo'); });
      p.classList.add('mt-activo');
      aplicar(false);
    });
  });

  if (swatchesColor.length || pillsCantidad.length) {
    refrescarPrecios();
    aplicar(false);
  }
}

function initRotadorProducto() {
  var rotador = document.querySelector('[data-mt-rotador]');
  if (!rotador) return;
  var imgs = rotador.querySelectorAll('.mt-rotador-img');
  if (imgs.length < 2) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var indice = 0;
  setInterval(function () {
    imgs[indice].classList.remove('mt-activa');
    indice = (indice + 1) % imgs.length;
    imgs[indice].classList.add('mt-activa');
  }, 2600);
}

function initTiltCards() {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;
  var tarjetas = document.querySelectorAll('.mt-beneficio-card, .mt-color-media');
  tarjetas.forEach(function (card) {
    card.style.transformStyle = 'preserve-3d';
    card.style.willChange = 'transform';
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      var rotY = x * 10;
      var rotX = y * -10;
      card.style.transform = 'perspective(700px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) translateY(-6px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}
